import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { Chip } from "@mui/material";

const OrderSummary = ({ order }) => {
  const [expanded, setExpanded] = useState(true);

  if (!order) return null;

  // Mock customer data (in real app, this would come from the order)
  const customer = {
    firmName: order.firmName,
    ownerName: "Chaitanya Goyal",
    phoneNumber: order.phoneNumber,
    gstin: order.gstin || "78115264569",
    address: order.address,
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg">
      <div
        className="flex items-center justify-between px-6 py-4 border-b cursor-pointer"
        onClick={() => setExpanded(!expanded)}>
        <h2 className="text-base font-medium text-gray-800">
          Order & Customer Information
        </h2>
        <button className="p-1 rounded-full hover:bg-gray-100">
          {expanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
        </button>
      </div>

      {expanded && (
        <div className="px-6 py-5">
          <div className="grid md:grid-cols-2 gap-6">
            {/* Order Information */}
            <div>
              <h3 className="text-xs font-medium text-gray-500 uppercase mb-3">
                Order Details
              </h3>

              <table className="w-full text-sm">
                <tbody>
                  <tr>
                    <td className="py-1.5 text-gray-500 pr-4 align-top w-1/3">
                      Order ID:
                    </td>
                    <td className="py-1.5 font-medium">
                      #{order._id.substring(3)}
                    </td>
                  </tr>
                  <tr>
                    <td className="py-1.5 text-gray-500 pr-4 align-top">
                      Date:
                    </td>
                    <td className="py-1.5 font-medium">{order.date}</td>
                  </tr>
                  <tr>
                    <td className="py-1.5 text-gray-500 pr-4 align-top">
                      Status:
                    </td>
                    <td className="py-1.5">
                      <Chip
                        label={order.status}
                        size="small"
                        sx={{
                          backgroundColor:
                            order.status === "Pending"
                              ? "#FEF9C3"
                              : order.status === "Approved"
                              ? "#DCFCE7"
                              : "#FEE2E2",
                          color:
                            order.status === "Pending"
                              ? "#854D0E"
                              : order.status === "Approved"
                              ? "#166534"
                              : "#B91C1C",
                          fontWeight: 500,
                          fontSize: "0.7rem",
                          height: "20px",
                          borderRadius: "4px",
                          "& .MuiChip-label": { px: 1.5 },
                        }}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Customer Information */}
            <div className="border-t md:border-t-0 md:border-l border-gray-100 pt-4 md:pt-0 md:pl-6 mt-4 md:mt-0">
              <h3 className="text-xs font-medium text-gray-500 uppercase mb-3">
                Customer Details
              </h3>

              <table className="w-full text-sm">
                <tbody>
                  <tr>
                    <td className="py-1.5 text-gray-500 pr-4 align-top w-1/3">
                      Firm:
                    </td>
                    <td className="py-1.5 font-medium">{customer.firmName}</td>
                  </tr>
                  <tr>
                    <td className="py-1.5 text-gray-500 pr-4 align-top">
                      Owner:
                    </td>
                    <td className="py-1.5 font-medium">{customer.ownerName}</td>
                  </tr>
                  <tr>
                    <td className="py-1.5 text-gray-500 pr-4 align-top">
                      GSTIN:
                    </td>
                    <td className="py-1.5 font-medium">{customer.gstin}</td>
                  </tr>
                  <tr>
                    <td className="py-1.5 text-gray-500 pr-4 align-top">
                      Phone:
                    </td>
                    <td className="py-1.5 font-medium">
                      {customer.phoneNumber}
                    </td>
                  </tr>
                  <tr>
                    <td className="py-1.5 text-gray-500 pr-4 align-top">
                      Address:
                    </td>
                    <td className="py-1.5 font-medium">{customer.address}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrderSummary;
